import { Component, OnInit } from '@angular/core';
import { PharmacieService } from './service/pharmacie.service';
import { GlobalService } from './service/global.service';
import { PharmacieDto } from './DTO/pharmacie.dto';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'monpharmacien-web';
  loading_gif: any = 'assets/images/loading.gif';

  constructor(
    public globalService: GlobalService,
    protected pharmacieService: PharmacieService
  ) {}

  ngOnInit() {
  }
  
}
